<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          outlined
          label
          small
          :color="plano.color ? plano.color : 'orange'"
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{ plano.status?.descricao ?? "Aguardando Confirmação" }}
        </v-chip>
      </template>
      <v-list v-if="permitirRolesParaGestores() >= 0">
        <v-list-item v-for="situacao of $constants.situacoesPlanos" :key="situacao.descricao" link>
          <v-list-item-title @click="() => atualizarSituacao(plano, situacao)">
            {{ situacao.descricao ? situacao.descricao : "- - -" }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["plano"],
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  methods: {
    async atualizarSituacao(plano, situacao) {
      const response = await this.$services.planosService.updateBimestral(plano.id, situacao.id);
      if (response) {
        this.$emit("update", response);
      }
    },
    permitirRolesParaGestores() {
      try {
        const userLocal = this.user.roles ? this.user.roleName : [];
        return this.$constants.rolesParaGestores.findIndex((elem) => {
          return elem.name === userLocal;
        });
      } catch (error) {
        this.$handleError(error);
      }
      return false;
    },
  },
};
</script>
